/* eslint-disable react-hooks/exhaustive-deps */
import { Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Collapse, IconButton, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Error, FindInPageOutlined, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { AutocompleteChangeReason } from '@mui/material/useAutocomplete';
import { useCallback, useEffect, useMemo, useState } from "react"
import { ComponenteEstrutura, ListagemItem, EstruturaListagem, EstruturaListagemResponse } from "src/components/projetos/types"
import { Layout } from "../../layouts";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { apiNoLoading, IDataResponse } from "src/framework/providers/api"
import { setPersonalizadoTabDisabledStatus, setPersonalizadoTabDoneStatus } from "src/store/vendas/projetos/actions"
import theme from "src/theme/light"
import { TabName } from "../.."
import { TIPO_INVERSOR_ID } from "src/components/projetos/constants"
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert"
import EstruturasListMobile from "src/components/projetos/containers/Mobile/EstruturasListMobile"
import "./styles.css"
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { useObservable } from "src/framework/store/storeUtil";
import { fraseParceiro$ } from "src/store/global.store";
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store";

interface EstruturasProps {
  onClickBack: () => void
  onClickNext: () => void
  tab: TabName
}

const useStyles = makeStyles({
  tableHeaderRow: {
    height: 60,
    backgroundColor: "#0000000D",
    cursor: 'pointer'
  },
  collapseContainer: {
    marginBottom: 20
  },
  warningText: {
    color: theme.palette.warning.main
  },
  confirmationButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  }
})

const Estruturas = ({ tab, onClickBack, onClickNext }: EstruturasProps) => {
  const classes = useStyles()
  const projetoState = useProjetoPersonalizadoHibridoStore(store => store.state.data);
  const { changeValue, changeModal } = useProjetoPersonalizadoHibridoStore(store => store.actions);
  const [estruturasSelecionadas, setEstruturasSelecionadas] = useState<EstruturaListagem[]>(projetoState.estruturasSelecionadas || [])
  const [estruturasOpts, setEstruturasOpts] = useState<EstruturaListagem[]>([])
  const [fraseParceiroExibidoList] = useState<number[]>([]);

  const fraseParceiroPowerAlert = useObservable(fraseParceiro$);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const labelPosicao = useCallback((posicao:string) => {
    switch (posicao) {
      case 'paisagem':
        return 'Paisagem';
      case 'retrato':
        return 'Retrato';
      case 'ambos':
        return 'Retrato / paisagem';
    }
  }, [])

  const selectedModulo = useMemo(()=>{
    const modulos = projetoState?.modulosList || []
    return modulos.find(item => item.selecionado)
  },[projetoState?.modulosList])

  useEffect(() => {
    // Executa na edição do projeto, pois, as estruturas vem no campo `estruturas_edicao` do projetoState
    if (!!estruturasOpts.length && !estruturasSelecionadas.length && !projetoState.estruturasSelecionadas?.length && projetoState.estruturas_edicao.length) {
      const newEstruturasSelecionadas = parserEstruturas(estruturasOpts, projetoState.estruturas_edicao || []);

      changeValue({...projetoState, estruturas_edicao: [], estruturasSelecionadas: newEstruturasSelecionadas })
      setEstruturasSelecionadas(newEstruturasSelecionadas)
    }
  },[estruturasOpts, estruturasSelecionadas, projetoState, projetoState.estruturasSelecionadas, projetoState.estruturas_edicao, changeValue])

  const parserEstruturas = (estruturas: EstruturaListagem[], estruturasSelecionadasEditadas: EstruturaListagem[]): EstruturaListagem[] => {
    const newEstruturasSelecionadas = estruturas.reduce<EstruturaListagem[]>((resultado, estrutura) => {
      const estruturaEditada = estruturasSelecionadasEditadas.find((estruturaEditada) => Number(estruturaEditada.estruturas_grupo_id) === Number(estrutura.estruturas_grupo_id));
      const itensProcessados = estrutura.items.map((item) => {
        const itemEditado = estruturaEditada?.items?.find((itemEditado) => Number(itemEditado.componente_id) === Number(item.componente_id));
        return {
          ...item,
          quantidade: itemEditado?.quantidade ?? item.quantidade ?? 0,
        };
      });

      const quantidade = itensProcessados.reduce((total, item) => total + Number(item.quantidade || 0), 0);
      if (quantidade <= 0) {
        return resultado;
      }

      resultado.push({
        ...estrutura,
        opened: quantidade > 0,
        items: itensProcessados,
        componente_id:
          itensProcessados.find(
            (item) => Number(item.quantidade) > 0
          )?.componente_id ?? 0,
        quantidade,
      });

      return resultado;
    }, []);

    return newEstruturasSelecionadas;
  }

  const verificaEstruturasSelecionas = (estruturas: EstruturaListagem[], estruturasSelecionadasEditadas: any[]): boolean => {
    let atualizarEstruturaSelecionada = false;
    if(estruturasSelecionadasEditadas && estruturasSelecionadasEditadas.length){
      for(const estrutura of estruturasSelecionadasEditadas){
        atualizarEstruturaSelecionada = estruturas.findIndex(edicao => edicao.estruturas_grupo_id === estrutura.estruturas_grupo_id) < 0;
        if(atualizarEstruturaSelecionada){
          return atualizarEstruturaSelecionada;
        } 
      }
    }

    return atualizarEstruturaSelecionada;
  }
  
  useEffect(() => {
    if (projetoState?.alterou_inversor && estruturasOpts?.length) {
      projetoState?.estruturasSelecionadas?.forEach((item) => {
        const estruturasIds = estruturasOpts?.map(estrutura => estrutura?.estrutura_id);
        const gruposIds = estruturasOpts?.map(estrutura => estrutura?.estruturas_grupo_id);
        if (item?.estrutura_id && (!estruturasIds?.includes(item?.estrutura_id) || !gruposIds?.includes(item?.estruturas_grupo_id))) {
          const newEstruturas = estruturasSelecionadas.filter((estrutura) => estrutura.estrutura_id !== item?.estrutura_id || estrutura.estruturas_grupo_id !== item?.estruturas_grupo_id)
          changeValue({ estruturasSelecionadas: newEstruturas })     
          setEstruturasSelecionadas(newEstruturas)
        }
      })
    }
  }, [estruturasOpts, estruturasSelecionadas, projetoState, changeValue])

  useEffect(()=>{
    if (tab !== 'estruturas') return;
    if (!selectedModulo) return;
    
    const currentRegioes = projetoState.regioes || []
    if (!currentRegioes.length) return;

    const potencia = Number(selectedModulo.quantidade || 0) * Number(selectedModulo.potencia || 0) / 1000

    const tipoInversor = TIPO_INVERSOR_ID[projetoState.tipo_inversor?.value || 0];
    let pathUrl = `/estoque/estruturas/modulos/${selectedModulo.componente_id}?potencia=${potencia}&regiao_id=${currentRegioes.map((item: any) => item.id).join(',')}&segmento=on`;
    if (tipoInversor) pathUrl += `&inversor=${tipoInversor}`
    apiNoLoading.get({
      url: pathUrl
    }).then((res: IDataResponse<EstruturaListagemResponse[]>) => {
      const items = res.data || []
      const filterEstruturas = items?.filter(item => 
        [tipoInversor, "todos"]?.includes(item?.inversor) &&
        !!item.grupos.length && 
        item.grupos?.map(grupo => 
          grupo?.status && 
          [tipoInversor, "todos"]?.includes(grupo?.inversor) && 
          grupo.id
        )?.includes(item.estruturas_grupo_id)
      );
      const payload = filterEstruturas.map((item): EstruturaListagem => {
        const findGrupo = item.grupos?.find(g => g.id === item.estruturas_grupo_id) || item.grupos?.[0];
        const posicaoGrupo = labelPosicao(findGrupo?.posicao);
        return {
          estrutura_id: item.id,
          id: Number(item.estruturas_grupo_id ? `${item.id}.${item.estruturas_grupo_id}` : item.id),
          nome: posicaoGrupo ? `${item.nome} - ${posicaoGrupo}` : item?.nome,
          estruturas_grupo_id: item.estruturas_grupo_id,
          status: (item?.status && findGrupo?.status),
          posicao: findGrupo?.posicao,
          items: findGrupo ? findGrupo.componentes.map((componente: ComponenteEstrutura): ListagemItem => {
            return {
              altura: Number(componente.altura),
              categoria_componentes_id: Number(componente.categoria_componentes_id),
              componente_id: Number(componente.id),
              nome: componente.nome || '',
              descricao: componente.descricao || '',
              largura: Number(componente.largura),
              peso: Number(componente.peso),
              quantidade: 0,
              potencia: 0,
              valor: 0,
              estruturas_grupo_id: componente.estruturas_grupo_id,
              valor_unitario: 0,
              exibir_popup_parceiro: componente.exibir_popup_parceiro || false,
            }
          }) : []
        }
      })

      const _estruturasOpts = payload?.filter(estrutura => estrutura?.status);

      setEstruturasOpts(_estruturasOpts);

      // executa como é uma criação de projeto 
      if(estruturasSelecionadas.length && projetoState.estruturasSelecionadas?.length && !projetoState.estruturas_edicao.length && verificaEstruturasSelecionas(_estruturasOpts, projetoState.estruturasSelecionadas || [])) {
        const newEstruturasSelecionadas = parserEstruturas(_estruturasOpts, projetoState.estruturasSelecionadas || []);
  
        changeValue({ estruturasSelecionadas: newEstruturasSelecionadas });
        setEstruturasSelecionadas(newEstruturasSelecionadas);
      }
    })
  },[tab, selectedModulo, projetoState.regioes, projetoState.estruturas_edicao, changeValue])

  const handleChangeOpenedStatus = useCallback((index: number) => {
    const newEstruturas = estruturasSelecionadas.map((item, i) => {
      if (i === index) return { ...item, opened: !item.opened }
      return item
    })
    setEstruturasSelecionadas(newEstruturas)
  }, [estruturasSelecionadas])

  const handleChangeItemQuantity = useCallback((estruturaId: number, itemId: number, value: any) => {
    const newEstruturasSelecionadas = estruturasSelecionadas.map(estrutura => {
      if(estrutura.id === estruturaId) {
        return {
          ...estrutura,
          items: estrutura.items.map(item => {
            if(item.componente_id === itemId) {
              if(item.exibir_popup_parceiro) {
                const idx = fraseParceiroExibidoList.findIndex(c => c === itemId);
                if(idx < 0 && value > 0) {
                  showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
                  fraseParceiroExibidoList.push(itemId);
                } else {
                  if(value === 0) {
                    fraseParceiroExibidoList.splice(idx, 1);
                  }
                }
              }
              return {  ...item, quantidade: value }
            }
            return item;
          })
        }
      }
      return estrutura
    })

    changeValue({ estruturasSelecionadas: newEstruturasSelecionadas });
    setEstruturasSelecionadas(newEstruturasSelecionadas)
  }, [projetoState, changeValue, estruturasSelecionadas])

  const renderEstruturas = useCallback(()=>{

    if (isMobile) {
      return (
        <EstruturasListMobile
          estruturasList={estruturasSelecionadas || []}
          handleChangeItemQuantity={handleChangeItemQuantity}
          handleChangeOpenedStatus={handleChangeOpenedStatus}
          handleOpenModalDadosTecnicos={changeModal}
        />
      )
    }

    return (
      <>
        {estruturasSelecionadas.map((estrutura, index) => (
          <Collapse key={estrutura.id} className={classes.collapseContainer} in={estrutura.opened} collapsedSize={60}>
            <TableContainer component={Paper}>
              <Table aria-label="listagem de modulos disponíveis">
                <TableHead>
                  <TableRow className={classes.tableHeaderRow} onClick={() => handleChangeOpenedStatus(index)}>
                    <TableCell align='left'><strong>{estrutura.nome}</strong></TableCell>
                    <TableCell align='center'><strong>Quantidade</strong></TableCell>
                    <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
                    <TableCell align='center'>
                      {estrutura.opened ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {estrutura.items.map(item => (
                    <TableRow key={item.componente_id}>
                      <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                        <Box display='flex'>
                          <Box textAlign={'left'}>
                            <Typography variant='body1' color='textPrimary'>
                              <strong>{item.nome}</strong>
                            </Typography>
                            <Typography variant='body2' color='textSecondary'>
                              <span className={classes.warningText}><strong>Essa opção inclui:</strong></span> {item.descricao}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align='center' component="th">
                        <Box width="180px" margin={"0 auto"}>
                          <InputQuantidade value={item.quantidade} onChange={(v: any) => handleChangeItemQuantity(estrutura.id, item.componente_id, v)} />
                        </Box>
                      </TableCell>
                      <TableCell align='center' component="th">
                        <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                          <IconButton size="large" onClick={() => item.componente_id && changeModal({ detalhesComponenteId: item.componente_id })}>
                            <FindInPageOutlined htmlColor="black" />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell align='center' component="th" />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        ))}
      </>
    );
  },[classes, handleChangeItemQuantity, estruturasSelecionadas, handleChangeOpenedStatus, changeModal])

  const handleOpenRemoveEstuturaModal = useCallback((onConfirm: () => void) => {
    confirmationDialog.setup({
      title: "Atenção!",
      subtitle: 'Exclusão de tipo de estrutura.',
      headerIcon: <Error color="error" />,
      content: (
        <>
          <span>Você tem certeza que deseja excluir esse tipo de estrutura?</span><br/>
          <span>Há produtos selecionados nesta seção que serão descartados. Por isso, reveja se a quantidade das estruturas mantidas será suficiente para a instalação do gerador.</span>
        </>
      ),
      noText: 'Cancelar',
      yesText: 'Excluir',
      submitButtonClassName: classes.confirmationButton,
      onClose: () => {
          confirmationDialog.close();
      },
      onConfirmation: () => {
        onConfirm()
      }
    })
    confirmationDialog.open()
  }, [classes.confirmationButton])

  const nextButtonIsDisabled = useMemo(()=>{
    return false
  },[])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('acessorios', nextButtonIsDisabled)
    setPersonalizadoTabDoneStatus('estruturas', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  return (
    <Layout nextButtonIsDisabled={nextButtonIsDisabled} onClickBack={onClickBack} onClickNext={onClickNext} title="Estrutura" subtitle="Escolha a estrutura que melhor atenderá este projeto." >
      <Box p={2} className="estruturas-personalizado">
        <Box mt={isMobile ? 0 : 3} mb={3}>
          <InputComboBoxList
            multiple
            id={`select-estruturas`}
            key={`select-estruturas`}
            label={"Tipo de estrutura"}
            textField="nome"
            valueField="id"
            options={estruturasOpts ? estruturasOpts.filter(item => !!item.items.length) : []}
            value={estruturasSelecionadas}
            autoComplete
            renderOptions={(option?: EstruturaListagem) => {
              return `${option?.nome}`
            }}
            renderOptionsLabel={(option?: EstruturaListagem) => {
              return `${option?.nome}`
            }}
            onChange={(value: EstruturaListagem[], item?: EstruturaListagem, reason?: AutocompleteChangeReason) => {
              if (reason === 'clear') {
                const totalSelected = estruturasSelecionadas.reduce((acc, curr) => acc + curr.items.reduce((acc, curr) => acc + curr.quantidade, 0), 0)
                if (totalSelected === 0){
                  changeValue({ estruturasSelecionadas: [] });
                  setEstruturasSelecionadas([])
                  return;
                }                
                handleOpenRemoveEstuturaModal(() => {
                  changeValue({ estruturasSelecionadas: [] });
                  setEstruturasSelecionadas([])
                })
                return
              }

              if (reason === 'removeOption') {
                const currentItem = estruturasSelecionadas.find((estrutura) => estrutura.id === item?.id)
                const totalSelected = currentItem?.items?.reduce((acc, curr) => acc + curr.quantidade, 0) || 0
                const oldEstruturas = [...estruturasSelecionadas]
                const newEstruturas = oldEstruturas.filter((estrutura) => estrutura.id !== item?.id)
                if (totalSelected === 0) {
                  changeValue({ estruturasSelecionadas: newEstruturas })
                  setEstruturasSelecionadas(newEstruturas)
                  return
                } 
                handleOpenRemoveEstuturaModal(() => {
                  changeValue({ estruturasSelecionadas: newEstruturas })
                  setEstruturasSelecionadas(newEstruturas)
                })
                return;
              }

              if (value){
                const newEstruturas = value.map((item) => {
                  if (item) return { ...item, opened: item.opened !== undefined ? item.opened : true }
                  return item
                })
                setEstruturasSelecionadas(newEstruturas)
                return
              }

              changeValue({ estruturasSelecionadas: [] })   
              setEstruturasSelecionadas([])
            }}
            />
        </Box>

        {renderEstruturas()}
      </Box>
    </Layout>
  )
}

export { Estruturas }
